import { fetcher } from "utils";

import { MemberSerialized } from "typings";

export const post__members__auth__sign_in = (params: { email: string; password: string }): Promise<MemberSerialized> =>
  fetcher.post("/members/auth/sign_in", params);
